import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const ProtectedRoute = ({ isAccessible, redirectToPath, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAccessible ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: redirectToPath,
            state: { from: props.location },
          }}
        />
      )
    }
  />
)

export default ProtectedRoute
